<div class="flex h-72">
  <!-- Left Panel - Categories -->
  <div class="w-40 border-r border-surface-200 dark:border-surface-700">
    @for (category of categories; track category.name) {
      <div
        (click)="selectCategory(category)"
        [ngClass]="{
          'text-primary-700 dark:text-primary-300 font-semibold': selectedCategory() === category,
          'hover:text-primary-600 dark:hover:text-primary-400 text-surface-700 dark:text-surface-300': selectedCategory() !== category
        }"
        class="px-2 py-2 cursor-pointer transition-colors text-sm"
      >
        {{ category.name }}
      </div>
    }
  </div>

  <!-- Right Panel - Apps Grid -->
  <div class="flex-1 px-4 overflow-y-auto">
    <div class="grid grid-cols-3 gap-4">
      @for (app of selectedCategory().apps; track app.name) {
        @if (!app.current) {
          <div
            (click)="navigateToApp(app)"
            class="flex flex-col items-center gap-2 p-3 rounded-xl cursor-pointer transition-all bg-surface-50 dark:bg-surface-800/50 hover:bg-surface-100 dark:hover:bg-surface-800"
          >
            <div class="w-14 h-14 rounded-xl overflow-hidden">
              <img src="assets/images/zaeper-logo.jpg" alt="{{ app.name }}" class="w-full h-full object-cover" />
            </div>
            <div class="flex-1 flex items-center">
              <span class="text-sm font-medium text-surface-900 dark:text-surface-100 leading-tight text-center">{{ app.name }}</span>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
